// app/javascript/controllers/charity_parties_view_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["tableView", "cardsView", "tableButton", "cardsButton"]

    connect() {
        if (this.hasTableViewTarget && this.hasCardsViewTarget) {
            this.showTable()
        }
    }

    showTable(event) {
        if (event) event.preventDefault()

        // Toggle Views
        this.tableViewTarget.classList.remove("hidden")
        this.cardsViewTarget.classList.add("hidden")

        // Update Button Styles (Active state)
        this.tableButtonTarget.classList.add("bg-white", "dark:bg-slate-700", "shadow-sm", "text-primary", "dark:text-blue-400")
        this.tableButtonTarget.classList.remove("text-slate-500", "dark:text-slate-400")

        // Update Button Styles (Inactive state)
        this.cardsButtonTarget.classList.remove("bg-white", "dark:bg-slate-700", "shadow-sm", "text-primary", "dark:text-blue-400")
        this.cardsButtonTarget.classList.add("text-slate-500", "dark:text-slate-400")
    }

    showCards(event) {
        if (event) event.preventDefault()

        // Toggle Views
        this.cardsViewTarget.classList.remove("hidden")
        this.tableViewTarget.classList.add("hidden")

        // Update Button Styles (Active state)
        this.cardsButtonTarget.classList.add("bg-white", "dark:bg-slate-700", "shadow-sm", "text-primary", "dark:text-blue-400")
        this.cardsButtonTarget.classList.remove("text-slate-500", "dark:text-slate-400")

        // Update Button Styles (Inactive state)
        this.tableButtonTarget.classList.remove("bg-white", "dark:bg-slate-700", "shadow-sm", "text-primary", "dark:text-blue-400")
        this.tableButtonTarget.classList.add("text-slate-500", "dark:text-slate-400")
    }
}